export const xMarkWidth = 3; // how fat x-mark on the photo
export const zoomScaleBy = 1.05; // zoom sensitivity
